import {ReactComponent as LightGBM} from '../assets/LightGBMLogo.svg';
import {ReactComponent as LibrosaLogo} from '../assets/LiborsaLogo.svg';
// import {ReactComponent as SeabornLogo} from '../assets/SeabornLogo.svg';

const DSML = {
        title: "Data Science & ML",
        icons: [
        
        { icon: "logos:numpy", name: "NumPy" },
        { icon: "logos:tensorflow", name: "TensorFlow" },
        { icon: "devicon:jupyter", name: "Jupyter Notebook" },
        {name: "Google Colab", icon: "devicon:googlecolab"},
        { icon: "devicon:scikitlearn", name: "Scikit-learn" },
        { icon: "devicon:pandas", name: "Pandas" },
        { icon: "devicon:kaggle", name: "Kaggle" },
        { icon: "devicon:matplotlib", name: "Matplotlib" },
        { name: "Seaborn", icon: "devicon:seaborn",  },
        { icon: "simple-icons:scipy", name: "SciPy" },
        { name: "LightGBM", icon: LightGBM, isCustom: true},
        { name: "Librosa", icon: LibrosaLogo, isCustom: true },
        {icon: "devicon:huggingface", name: "Hugging Face"},
        {icon: "devicon:pytorch", name: "Pytorch"},
        {name: "Whisper", icon: "simple-icons:openai", isCustom: false},
        
        ]
};

export default DSML;